import {Component, HostBinding} from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class Footer {

    @HostBinding('class') classes = 'global-footer';

    constructor() {
    }

}
